import { DatePicker, Input, InputNumber, Select, Button, Row } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { isMobile } from "../../extensions/design";
import TriStateCheckbox from "../tri-state-checkbox";
import "./filter-item.css";

/**
 * - allowSearch (boolean) — если false, то showSearch выключен и ввод текста не фильтрует варианты.
 */
export const FilterItem = ({ label, type, value, onChange, onRemove, options, allowSearch = true, width, removable = true }) => {
  const safeOptions = options?.map((opt) => ({
    ...opt,
    label: <span title="">{opt.label}</span>,
    _rawLabel: opt.label,
  }));
  
  const getLabelText = (node) => {
    if (node == null) return "";
    if (typeof node === "string" || typeof node === "number") return String(node);
    if (Array.isArray(node)) return node.map(getLabelText).join("");
    
    if (typeof node === "object") {
      
      if ("props" in node && node.props && "children" in node.props) {
        return getLabelText(node.props.children);
      }
      
      try {
        return String(node);
      } catch (e) {
        return "";
      }
    }
    return "";
  };

  
  const optionFilter = (input, option) => {
    try {
      const maybeRaw = option?._rawLabel ?? option?.label;
      const text = getLabelText(maybeRaw);
      return text.toLowerCase().includes(String(input).toLowerCase());
    } catch (e) {
      return false;
    }
  };

  const renderField = () => {
    switch (type) {
      case "text":
        return (
          <div className="filter-wrapper" style={isMobile ? {flex:"0"} : {}}>
            <Input value={value} onChange={(e) => onChange(e.target.value)} style={width ? { width:width} : {}} className="filter-input"/>
          </div>
        );
      case "number":
        return (
          <div className="filter-wrapper" style={isMobile ? {flex:"0"} : {}}>
            <InputNumber value={value} onChange={onChange} style={width ? { width:width} : {}} className="filter-number"/>
          </div>
        );
      case "select":
        return (
          <div className="filter-wrapper" style={isMobile ? {flex:"0"} : {}}>
            <Select value={value} onChange={onChange} options={safeOptions} placeholder="Выберите" style={width ? { width:width} : {}} className="filter-select"
              showSearch={allowSearch}
              {...(allowSearch ? { filterOption: optionFilter } : {})}
            />  
          </div>
        );
      case "multiselect":
        return (
          <div className={ isMobile ? "filter-wrapper-mobile" : "filter-wrapper"}>
            <Select mode="multiple" value={value} onChange={onChange} options={safeOptions} placeholder="Выберите несколько" style={width ? { width:width} : {}} className="filter-select"
              showSearch={allowSearch}
              maxTagCount={isMobile ? 1 : 3}
              maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
              {...(allowSearch ? { filterOption: optionFilter } : {})}
            />
          </div>
        );
      case "tristate":
        return (
          <div className={isMobile ? "filter-wrapper-mobile" : "filter-wrapper"}>
            <TriStateCheckbox value={value === undefined ? null : value} onChange={onChange} />
          </div>
        );
      case "date":
        const [startDate, endDate] = value || [];
        return (
          <Row span={6} className="filter-date-range">
            <DatePicker value={startDate} onChange={(val) => onChange([val, endDate])} style={width ? { width:width} : {}} placeholder="С" className="filter-date" format="DD.MM.YYYY"/>
            <DatePicker value={endDate} onChange={(val) => onChange([startDate, val])} style={width ? { width:width} : {}} placeholder="По" className="filter-date" format="DD.MM.YYYY"/>
          </Row>
        );
      default:
        return null;
    }
  };

  return (
    <div className="filter-item">
      
      {isMobile ? 
      <>
        <div className="filter-content-mobile" style={isMobile ? {display: "flex", flex:""} : {}}>
          {renderField()}
          <p/>
          {removable && <Button icon={<CloseOutlined />} onClick={onRemove} />}
        </div>
      </> :
      <>
        <div className="filter-label">{label}</div>
        <div className="filter-content">{renderField()}</div>
        {removable && <Button icon={<CloseOutlined />} onClick={onRemove} />}
      </>
      }
    </div>
  );
};

export default FilterItem;
